import { Button } from '@material-ui/core';

import React from 'react';

export default function CustomButton(props){
    return(
        <Button onClick={props.action} style={{borderRadius: 33, width:200, height:55, backgroundColor: props.buttonColor, fontSize: 22, fontWeight:'300', color:props.textColor, textTransform:'none'}}>
            <props.buttonIcon/>{' '}<h5>{props.buttonText}</h5>
        </Button>
    )
}